import { render, staticRenderFns } from "./BpPaginatorOld.vue?vue&type=template&id=22eaaa94&scoped=true&"
import script from "./BpPaginatorOld.vue?vue&type=script&lang=js&"
export * from "./BpPaginatorOld.vue?vue&type=script&lang=js&"
import style0 from "./BpPaginatorOld.vue?vue&type=style&index=0&id=22eaaa94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eaaa94",
  null
  
)

export default component.exports